export function objValue(obj, key) {
    return obj[key];
}
//# sourceMappingURL=typescript.js.map